@if (loading()) {
  <div class="loading-indicator">
    <div class="arrow-cont">
      <img src="assets/img/loader/arrow-load.svg" alt="spinner" class="arrow-load" />
    </div>
    <img src="assets/img/loader/taxi-load.svg" alt="taxi-load" class="taxi-load" />
  </div>
}
